import type { ApiData } from './api-options';

/**
 * Parses a Response body into an ApiData value.
 * Returns the raw text for text/plain responses. Otherwise attempts JSON.parse,
 * falling back to raw text if parsing fails.
 */
export async function parseResponseBody(response: Response): Promise<ApiData> {
  const contentType = response.headers.get('content-type');
  const text = await response.text();

  if (contentType?.includes('text/plain')) {
    return text;
  }

  try {
    return JSON.parse(text) as ApiData;
  } catch {
    return text;
  }
}
